import FooterLinks from '@components/footer-links';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import {
    createConfigurationValuesService,
    createTranslationService
} from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';
import { defaultTo } from 'lodash';
import { observer } from 'mobx-react';
import * as React from 'react';

enum FooterLinksTranslation {
    support = 'support',
    privacy = 'privacy',
    faqs = 'faqs'
}

@observer
class FooterLinksContainer extends React.Component {
    static readonly translationContext: string = 'footerLinks';
    readonly translations = cacheTranslations(
        createTranslationService(),
        FooterLinksTranslation,
        FooterLinksContainer.translationContext
    );
    readonly configurationValuesService: IConfigurationValuesService = createConfigurationValuesService();
    // Can move to configuration constant later as footerLinks
    /*
        Array<{
            url: string;        // link to open
            label: string;      // key to translate the label
        }>
     */
    // The default is English here as this component could be displayed in an error state where the translations are not available
    // TODO: Move hardcoded SJ links to configuration
    render() {
        return (
            <FooterLinks links={[
                {
                    url: this.configurationValuesService.supportUrl || 'https://www.swipejobs.com/support',
                    label: defaultTo(this.translations.support, 'Support')
                },
                {
                    url: this.configurationValuesService.privacyPolicyUrl || 'https://www.swipejobs.com/privacy',
                    label: defaultTo(this.translations.privacy, 'Privacy')
                },
                {
                    url: this.configurationValuesService.faqUrl || 'https://www.swipejobs.com/support',
                    label: defaultTo(this.translations.faqs, 'FAQs')
                }
            ]}/>
        );
    }
}

export default FooterLinksContainer;



// WEBPACK FOOTER //
// ./src/containers/footer-links/index.tsx